<script setup>
import { PhxDesignDetailsHighlightModal } from '@phx-styleguides/iwc';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  id: {
    type: String,
    required: true,
  },
  triggerId: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  slides: {
    type: Array,
    required: true,
  },
});

const { t } = useI18n();

const closeButton = computed(() => ({
  label: t('Accessibility.modal.close'),
}));
</script>

<template>
  <phx-design-details-highlight-modal
    :label="label"
    :slides="slides"
    :close-button="closeButton"
    :trigger-teleport-id="`#${triggerId}`"
    trigger-label="triggerLabel"
  />
</template>
